import { render, staticRenderFns } from "./MemberAscendList.vue?vue&type=template&id=45bb2e84&scoped=true"
import script from "./MemberAscendList.vue?vue&type=script&lang=js"
export * from "./MemberAscendList.vue?vue&type=script&lang=js"
import style0 from "./MemberAscendList.vue?vue&type=style&index=0&id=45bb2e84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bb2e84",
  null
  
)

export default component.exports